import React, {useEffect} from 'react';
import {fetchCasesById} from '../../features/thunks';
import {useDispatch, useSelector} from 'react-redux';
import {selectCaseById} from '../../features/casesSlice';
import {formatDate, FormatName} from '../../util/format';
import {UserAvatar} from '@/components/UserAvatar';
import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle
} from '@/components/ui/dialog';

type CaseParticipantsModalProps = {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    caseId: string | null;
}

const CaseParticipantsModal = ({open, onOpenChange, caseId}: CaseParticipantsModalProps) => {
    const dispatch = useDispatch();
    const currentCase = useSelector((state) => selectCaseById(state, caseId || ''));

    useEffect(() => {
        if (caseId) {
            dispatch(fetchCasesById({caseId}));
        }
    }, [dispatch, caseId]);


    if (!caseId || !currentCase) {
        return null;
    }

    const participants = (currentCase.participants || []).filter(u => u.id);

    return (
        <Dialog open={open} onOpenChange={onOpenChange}>
            <DialogContent className="sm:max-w-[425px]">
                <DialogHeader>
                    <DialogTitle>Registered members</DialogTitle>
                    <DialogDescription>
                        {currentCase.register_count}/{currentCase.register_max}
                    </DialogDescription>
                </DialogHeader>
                <div className="flex flex-col gap-4 py-4 h-full">
                    {participants.length === 0 ? (
                        <p className="text-muted-foreground text-center">
                            No participants yet
                        </p>
                    ) : null}

                    {participants.map((u) => {
                        return (
                            <div className="flex items-center space-x-4" key={u.id}>
                                <UserAvatar userId={u?.id} className="h-12 w-12"/>
                                <div>
                                    <p className="text-sm font-medium leading-none">
                                        {u.first_name} {u.last_name}
                                    </p>
                                    <p className="text-sm text-muted-foreground">
                                        Member since: {formatDate({ts: u.created, format: FormatName.Medium})}
                                    </p>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </DialogContent>
        </Dialog>
    )
};

export default CaseParticipantsModal;


